import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://localhost:3001/api',
  // baseURL: 'https://api.kmk-ims.com',
  // baseURL: 'https://dev-api.kmk-ims.com',
  baseURL: process.env.REACT_APP_API_URL || 'https://dev-api.kmk-ims.com',
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

instance.interceptors.response.use(
  response => response,
  error => {
    if (
      error.response &&
      error.response.status === 401 &&
      !['/', '/login'].includes(window.location.pathname)
    ) {
      // alert('登入逾時，請重新登入');
      localStorage.removeItem('token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('role');
      console.log('登入逾時，請重新登入');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default instance;
